<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/voormeldingen">Voormeldingen</a>
				</li>
				<li>
					<span>{{asn.reference}}</span>
				</li>
			</ul>
		</div>
        <div class="o-dashboard__panels" v-if="asn.client">
			<div class="row collapse">

				<div class="column small-12 xlarge-8">
					<c-block-prenotification-info :asn="asn"></c-block-prenotification-info>

					<c-block-prenotification-products :orderNumber="asn.reference" />
				</div>
			</div>
		</div>

		<c-new-prenotification v-if="asn.client"
			v-show="modal"
			@close="modal=false"
			@added="load"
			:size="'medium'"
			:edit="true"
			:asn="asn"
			:title="'Voormelding aanpassen'">
		</c-new-prenotification>

		<c-remove-prenotification
			v-show="removeModal"
			:size="'medium'"
			:text="'voormelding'"
			@close="removeModal=false"
			@remove="remove()">
		</c-remove-prenotification>

	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CBreadcrumbs from '@components/Breadcrumbs';
import CBlockPrenotificationProducts from '@components/blocks/PreNotificationProducts';
import CBlockPrenotificationInfo from '@components/blocks/PreNotificationInfo';
import CNewPrenotification from '@app/modals/NewPrenotification';
import CRemovePrenotification from '@app/modals/Remove';

export default {
	mixins: [ View, Form ],
	components: { CBreadcrumbs, CBlockPrenotificationInfo, CBlockPrenotificationProducts, CNewPrenotification, CRemovePrenotification },
	data() {
		return {
			asn: [],
			modal: false,
			removeModal: false,
		}
	},
	methods: {
		load(){
			this.$xhr.get('/api/asns/' + this.$route.params.id).then( ({result}) => {
				this.asn = result;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Voormeldinggegevens kunnen niet worden ingeladen'});
			});
		},
		openModal() {
			this.modal = true;
		},
		openRemoveModal(){
			this.removeModal = true;
		},
		remove(){
			this.$xhr.delete('/api/asns/' + this.$route.params.id).then( ( {result}) => {
				this.$store.dispatch('toast/success', {title: 'Voormelding verwijderen', text: 'De voormelding is verwijderd'});
                close();
                window.location.replace("/voormeldingen");
			}).catch( (e) => {
                    this.$store.dispatch('toast/alert', {title: 'Voormelding verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
			});
		}
	},
	beforeUnmount(){
		this.$store.dispatch("listener/off", {
			event: 'new-prenotification',
			listener: this.openModal
		});
		this.$store.dispatch("listener/off", {
			event: 'remove-prenotification',
			listener: this.openRemoveModal
		});
	},
	created(){
		this.$store.dispatch("listener/on", {
			event: 'new-prenotification',
			listener: this.openModal
		});
		this.$store.dispatch("listener/on", {
			event: 'remove-prenotification',
			listener: this.openRemoveModal
		});
	},
	mounted(){
		this.load();
	}
}
</script>
